import { render } from "./SecondSectionImage.vue?vue&type=template&id=3332676a&scoped=true"
import script from "./SecondSectionImage.vue?vue&type=script&lang=ts"
export * from "./SecondSectionImage.vue?vue&type=script&lang=ts"

import "./SecondSectionImage.vue?vue&type=style&index=0&id=3332676a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3332676a"

export default script